import React from 'react';
import { Button, DatePicker, Form, Input, Select } from 'antd';
import { openNotification, extractApiErrorMessage } from '../../../utils';
import dayjs from 'dayjs';
import { APP_DATE_FORMAT } from 'config/constants';
import { createLeave, updateLeave, getLeave } from '../services/leaveService';
import { CreateLeaveDto } from '../types/Leave';

type LeaveFormValues = CreateLeaveDto & { dateRange?: [dayjs.Dayjs, dayjs.Dayjs] };

export default function LeaveForm({ id, onSuccess, referenceId }: { id?: number; onSuccess: () => void; referenceId?: number }) {
  const [form] = Form.useForm<LeaveFormValues>();
  
  React.useEffect(() => {
    if (id) {
      getLeave(id).then(d => {
        const data: any = { ...d };
        const start = data.startDate ? dayjs(data.startDate) : undefined;
        const end = data.endDate ? dayjs(data.endDate) : undefined;
        form.setFieldsValue({
          ...data,
          dateRange: start && end ? [start, end] : undefined,
        });
      });
    } else {
      form.resetFields();
    }
    
  }, [id, form]);
  const onFinish = async (values: LeaveFormValues) => {
    const data: any = { ...values };
    if (values.dateRange && values.dateRange.length === 2) {
      const [start, end] = values.dateRange;
      data.startDate = start?.toISOString();
      data.endDate = end?.toISOString();
    }
    delete data.dateRange;
    if (referenceId !== undefined) data.account = { id: referenceId };
    try {
      if (id) {
        await updateLeave(id, data);
        openNotification('success', 'Başarılı', 'P.K.M İzin Güncellendi');
      } else {
        await createLeave(data);
        openNotification('success', 'Başarılı', 'P.K.M İzin Eklendi');
      }
      onSuccess();
    } catch (e) {
      const message = extractApiErrorMessage(e, 'P.K.M İzin işlemi başarısız');
      openNotification('error', 'Hata', message);
    }
  };
  return (
    <>
      
      <Form form={form} onFinish={onFinish} layout='vertical'>
      <Form.Item name='type' label='İzin Türü' rules={[{ required: true }]}>
        <Select showSearch filterOption={(input, option) => ((option?.children?.toString()) || '').toLocaleLowerCase('tr').includes(input.toLocaleLowerCase('tr'))} placeholder='Seçiniz' style={{width:'100%'}}><Select.Option value='ANNUAL_PAID'>Yıllık Ücretli İzin</Select.Option><Select.Option value='SICK_WITH_REPORT'>Raporlu Hastalık İzni</Select.Option><Select.Option value='UNPAID'>Ücretsiz İzin</Select.Option><Select.Option value='EXCUSE'>Mazeret İzni</Select.Option><Select.Option value='MARRIAGE'>Evlilik İzni</Select.Option><Select.Option value='MATERNITY'>Doğum İzni</Select.Option><Select.Option value='NURSING'>Süt İzni</Select.Option><Select.Option value='PATERNITY'>Babalık İzni</Select.Option><Select.Option value='ADOPTION'>Evlat Edinme İzni</Select.Option><Select.Option value='BEREAVEMENT'>Ölüm (Vefat) İzni</Select.Option><Select.Option value='JOB_SEARCH'>Yeni İş Arama İzni</Select.Option></Select>
      </Form.Item>
      <Form.Item name='dateRange' label='Başlangıç ve Bitiş Tarihi' rules={[{ required: true, message: 'Tarih aralığı seçiniz' }]}>
        <DatePicker.RangePicker
          showTime={{ format: 'HH:mm', minuteStep: 5 }}
          format={APP_DATE_FORMAT}
          placeholder={['Başlangıç', 'Bitiş']}
          style={{ width: '100%' }}
        />
      </Form.Item>
      <Form.Item name='note' label='Not' rules={[{ required: true }]}>
        <Input.TextArea rows={3} style={{width:'100%'}} />
      </Form.Item>
      <Button htmlType='submit' type='primary' block>Kaydet</Button>
    </Form>
    </>
  );
}
